export default "__VITE_ASSET__DYr2yCgZ__"